module.exports = __webpack_public_path__ + "img/news_post_1.4a21f23d.png";